/* eslint-disable no-multi-str */
import { css, StyleSheet } from 'aphrodite';
import React, { useState } from 'react';
import { Map, Marker, TileLayer } from 'react-leaflet';
import L from 'leaflet';
import Card from 'react-bootstrap/Card';
import Carousel from 'react-bootstrap/Carousel';

import './map.css';
import foto_paskov from './assets/images/fotky/IMG_8753.jpg';
import foto_paskov1 from './assets/images/fotky/IMG_8757.jpg';
import foto_paskov2 from './assets/images/fotky/IMG_8759.jpg';
import foto_paskov3 from './assets/images/fotky/IMG_8762.jpg';
//import foto_paskov4 from './assets/images/fotky/IMG_8774.jpg';
//import foto_paskov5 from './assets/images/fotky/IMG_8775.jpg';

import foto_posta_ova from './assets/images/fotky/posta_ostrava_2_-_1.jpg';
import foto_posta_ova1 from './assets/images/fotky/posta_ostrava_2_-_2.jpg';
//import foto_posta_ova2 from './assets/images/fotky/posta_ostrava_-2_-3.jpg';
import foto_posta_ova3 from './assets/images/fotky/posta_Ostrava_2.jpg';

import foto_posta_poruba from './assets/images/fotky/posta_poruba_8.jpg';
import foto_posta_poruba1 from './assets/images/fotky/posta_poruba_8_(2).jpg';
import foto_posta_poruba2 from './assets/images/fotky/posta_poruba_8_(3).jpg';

import foto_martinov from './assets/images/fotky/rd_martinov_(2).jpg';
import foto_martinov1 from './assets/images/fotky/RD_Martinov.jpg';

import foto_sviadnov from './assets/images/fotky/RD_Sviadnov.jpg';
import foto_sviadnov1 from './assets/images/fotky/RD_Sviadnov1.jpg';
import foto_sviadnov2 from './assets/images/fotky/RD_Sviadnov2.jpg';
import foto_sviadnov3 from './assets/images/fotky/RD_Sviadnov3.jpg';
import foto_sviadnov4 from './assets/images/fotky/RD_Sviadnov4.jpg';

//import foto_zbrojnice_paskov from './assets/images/fotky/zbrojnice_Paskov.jpg';
import foto_zbrojnice_paskov1 from './assets/images/fotky/zbrojnice_Paskov3.jpg';
import foto_zbrojnice_paskov2 from './assets/images/fotky/zbrojnice_Paskov_(2).jpg';

import foto_zbrojnice_hostalkovice from './assets/images/fotky/zbrojnice_hostalkovice.jpg';


import marker from './assets/map/pin.svg';
import markerOrange from './assets/map/pin_orange.svg';
import shadow from './assets/map/marker-shadow.png';

function createMarkup(data) {
  return { __html: data };
};

export default function MapComponent() {
  const projs = [
    {
      id: 0,
      title: "Adaptace skleníku v areálu zámku Paskov",
      place: { lat: 49.7318550, lng: 18.2931694 },
      description: "Oprava historického skleníku v areálu zámku Paskov\
      <ul>\
        <li>Nová střecha, restaurátorské práce</li>\
        <li>Hodnota zakázky 2,7 mil Kč</li>\
      </ul>", //as html here
      images: [foto_paskov, foto_paskov1, foto_paskov2, foto_paskov3]
    },
    {
      id: 3,
      title: "Rekonstrukce budovy České pošty Ostrava 2",
      place: { lat: 	49.8517342, lng: 18.2686253 },
      // eslint-disable-next-line no-multi-str
      description: "Rekonstrukce interiéru budovy, rekonstrukce vstupu, oprava části fasády, výměna časti střechy\
      <ul>\
        <li>Hodnota zakázky 17,6 mil Kč</li>\
      </ul>", //as html here
      images: [foto_posta_ova, foto_posta_ova1, foto_posta_ova3]
    },
    {
      id: 4,
      title: "Rekonstrukce budovy České pošty Ostrava 8",
      place: { lat: 49.8298569, lng: 18.1746750 },
      // eslint-disable-next-line no-multi-str
      description: "Kompletní rekonstrukce interiéru a zázemí pošty, oprava památkově chráněné fasády, restaurátorské práce památkově chráněného interiéru\
      <ul>\
        <li>Hodnota zakázky 22,2 mil Kč</li>\
      </ul>", //as html here
      images: [foto_posta_poruba, foto_posta_poruba1, foto_posta_poruba2]
    },
    {
      id: 5,
      title: "Výstavba RD v Martinov",
      place: { lat: 49.8566556, lng: 18.1784722},
      // eslint-disable-next-line no-multi-str
      description: "Výstavba RD v pasivním standartu v Martinově\
      <ul>\
        <li>Hodnota zakázky  4,5 mil Kč</li>\
      </ul>", //as html here
      images: [foto_martinov, foto_martinov1]
    },
    {
      id: 6,
      title: "Výstavba RD Sviadnov",
      place: { lat: 49.6892556, lng: 18.3276164 },
      // eslint-disable-next-line no-multi-str
      description: "Kompletní výstavba RD na klíč\
      <ul>\
        <li>Hodnota zakázky 6,5 mil Kč</li>\
      </ul>", //as html here
      images: [foto_sviadnov, foto_sviadnov1, foto_sviadnov2, foto_sviadnov3, foto_sviadnov4]
    }
    ,
    {
      id: 7,
      title: "Výstavba Hasičské zbrojnice Paskov",
      place: { lat: 49.7335486, lng: 18.2933089 },
      // eslint-disable-next-line no-multi-str
      description: "Výstavba nové Hasičské zbrojnice v Paskově\
      <ul>\
        <li>Hodnota zakázky 18,6 mil Kč</li>\
      </ul>", //as html here
      images: [foto_zbrojnice_paskov1, foto_zbrojnice_paskov2]
    },
    {
      id: 8,
      title: "Výstavba Hasičské zbrojnice Hoštálkovice",
      place: { lat: 49.8475475, lng: 18.2116558},
      // eslint-disable-next-line no-multi-str
      description: "Rekonstrukce stávající budovy a přístavba skladu a věže pro sušení hadic\
      <ul>\
        <li>Hodnota zakázky 8,3 mil Kč</li>\
      </ul>", //as html here
      images: [foto_zbrojnice_hostalkovice]
    }
  ]
  const [projects] = useState(projs);
  const [active, setActive] = useState(0);

  const [index, setIndex] = useState(0);
  const [position, setPosition] = useState(projects[0].place)
  const [title, setTitle] = useState(projects[0].title);
  const [text, setText] = useState(projects[0].description);
  const [images, setImages] = useState(projects[0].images);


  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  const styles = StyleSheet.create({
    about: {
      width: '100%',
      height: 'auto',
      backgroundColor: '#E7421C', //rgba(15, 20, 36, 1)
      color: 'white',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    highlight: {
    },
    map: {
      width: "100%",
      paddingTop: "3em",
      display: "flex",
      flexDirection: "row",
      '@media (max-width: 1000px)': {
        display: "flex",
        flexDirection: "column",
        height: "auto",
      }
    },
    cardBox: {
      //width: '100em',
      flex: 2,
      minHeight: "500px",
      height: "700px", 
      borderRadius: 0,
      //height: '100%',
      '@media (max-width: 600px)': {
        minHeight: "auto",
        height: "auto", 
        width: "100%",
        //display: "none"
      }
    },
    card: {
      minHeight: "500px",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      '@media (max-width: 600px)': {
        minHeight: "auto",
        height: "auto",
        //display: "none"
      }
    },
    carouselStyle: {
      height: "450px",
      '@media (max-width: 600px)': {
        height: "100%",
      }
    },
    description: {
      '@media (max-width: 600px)': {
        //display: "none",
      }
    }
  });

  const pointerIcon = new L.Icon({
    iconUrl: marker,
    iconRetinaUrl: marker,
    iconAnchor: [30, 60],
    popupAnchor: [10, -44],
    iconSize: [60, 60],
    shadowUrl: shadow,
    shadowSize: [60, 60],
    shadowAnchor: [20, 60],
  });
  const pointerIconOrange = new L.Icon({
    iconUrl: markerOrange,
    iconRetinaUrl: markerOrange,
    iconAnchor: [30, 60],
    popupAnchor: [10, -44],
    iconSize: [60, 60],
    shadowUrl: shadow,
    shadowSize: [60, 60],
    shadowAnchor: [20, 60]
  });

  const markers = projects.map((project, index) => {
    return <Marker key={index} position={project.place} icon={index === active ? pointerIconOrange : pointerIcon} onClick={(event) => {
      setActive(index);
      setTitle(project.title);
      setText(project.description);
      setPosition(project.place);
      const images = [];
      project.images.map((image) => {
        images.push(image);
        return image;
      });
      setImages(images);
    }} />
  });

  const Item = (props) => {
    return (
      <Carousel activeIndex={index} onSelect={handleSelect} style={{flex: 2}}>
        {
          props.images.map((image, id) => {
            return (
              <Carousel.Item key={id} className={css(styles.carouselStyle)}>
                <Card.Img variant="top" src={image} style={{height: "100%"}}/>
              </Carousel.Item>
            )
          })
        }
      </Carousel>

    );
  }
  return (
    <div style={{ width: "100%", display: "flex", flexDirection: "column", padding: "3em", backgroundColor: "rgba(15, 20, 36, 0.05)" }}>
      <h3>Významné projekty 2020</h3>
      <div className={css(styles.map)}>
        <Map center={position} zoom={11} maxZoom={14}>
          <TileLayer
            attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {markers}
        </Map>
        <div className={css(styles.cardBox)}>
          <Card className={css(styles.card)}>
            <Item images={images}/>
            <Card.Body style={{ backgroundColor: "#0F1424", color: "white", padding: "2em"}}>
              <Card.Title><h5>{title}</h5></Card.Title>
              <Card.Text dangerouslySetInnerHTML={createMarkup(text)} className={css(styles.description)}/>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
}
